<template>
  <div class="px-2">
    <MapaDeSeparacao />
  </div>
</template>

<script>
import MapaDeSeparacao from '@/components/drp/configDrpAutomatizado/MapaDeSeparacao.vue'
export default {
  components: { MapaDeSeparacao },
  mounted() {
    this.$store.dispatch("MenuParametrizacaoIncludes/atualizarMenuParaAreaDeDistribuicao", this.$route.path);
  },
}
</script>

<style>

</style>
